import { inject, Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, OnInitEffects, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as TagActions from '../actions/tag.actions';
import * as GroupTagActions from '../actions/group-tag.actions';
import { GroupTagService } from '../services/group-tag.service';
import { TagService } from '../services/tag.service';

@Injectable()
export class TagEffects implements OnInitEffects {
  private groupTagService = inject(GroupTagService);
  private tagService = inject(TagService);

  loadTags$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TagActions.loadTags),
      switchMap(() => {
        return this.tagService.getTags().pipe(
          map((tags) => TagActions.loadTagsSuccess({ tags })),
          catchError((error) => of(TagActions.loadTagsFailure({ error })))
        );
      })
    );
  });

  loadGroupTagsForGroup$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupTagActions.loadGroupTagsForGroup),
      switchMap(({ groupId }) => {
        const groupTagsStream =
          this.groupTagService.fetchGroupTagsForUserGroup(groupId);
        return groupTagsStream.pipe(
          map((groupTags) => {
            return GroupTagActions.loadGroupTagsForGroupSuccess({ groupTags });
          }),
          catchError((error) => {
            return [GroupTagActions.loadGroupTagsForGroupFailure({ error })];
          })
        );
      })
    );
  });

  constructor(private actions$: Actions) {}

  ngrxOnInitEffects(): Action {
    return TagActions.loadTags();
  }
}
